import { Injectable } from '@angular/core';
import { Document } from '../../../types/document';
import printJS from 'print-js';
import { saveAs } from 'file-saver';

@Injectable()
export class DocumentUtils {
  print(document: Document) {
    printJS(URL.createObjectURL(document.data), document.mime.includes('image') ? 'image' : 'pdf');
  }
  download(document: Document) {
    saveAs(document.data, document.fileName);
  }
}
